import allCountries from '@/app-core/api/enums/CountryEnum'
import axios from 'axios'

export async function getCountry() {
  try {
    const response = await axios.get('https://ip2c.org/s')
    const result = (response?.data || '')?.toString()?.split(';') || null

    if (result?.length > 0 && result[0] === '1') return result[1]
    return null
  } catch (error) {
    return null
  }
}

// Credits: http://blog.vishalon.net/index.php/javascript-getting-and-setting-caret-position-in-textarea/
export function setCaretPosition(ctrl, pos) {
  // Modern browsers
  if (ctrl.setSelectionRange) {
    ctrl.focus()
    ctrl.setSelectionRange(pos, pos)

    // IE8 and below
  } else if (ctrl.createTextRange) {
    const range = ctrl.createTextRange()
    range.collapse(true)
    range.moveEnd('character', pos)
    range.moveStart('character', pos)
    range.select()
  }
}

export const defaultOptions = {
  placeholder            : '',
  label                  : '',
  disabledFetchingCountry: false,
  disabled               : false,
  disabledFormatting     : false,
  mode                   : '',
  invalidMsg             : '',
  required               : false,
  allCountries,
  defaultCountry         : '',
  enabledCountryCode     : false,
  enabledFlags           : true,
  preferredCountries     : [],
  onlyCountries          : [],
  ignoredCountries       : [],
  autofocus              : false,
  autocomplete           : 'on',
  name                   : 'telephone',
  wrapperClasses         : '',
  inputClasses           : '',
  inputId                : '',
  dropdownOptions        : {},
  inputOptions           : {},
  maxLen                 : 25,
  dynamicPlaceholder     : false
}

export default {
  options: {...defaultOptions}
}
